import { Action } from '@ngrx/store'

import * as PlanNumAction from '../../store/actions/plannum.action'
import { PlanNumCIF } from '../../shared/viewmodels/RegUtility';




export interface PlanNumState {
  readonly plannum: PlanNumCIF[];
}

// Section 1


const initialState: PlanNumState = {
  plannum: [{
    plannum: '' // Assuming 'name' is a property within NameCIF
  }]
};

// Section 2
export function reducer(state: PlanNumState = initialState, action: PlanNumAction.PlanNumActions) {

  // Section 3
  switch (action.type) {
    case PlanNumAction.ADD_PLANNUM:
      return {
        ...state,
        plannum: [...state.plannum, action.payload]
      };

    case PlanNumAction.REMOVE_PLANNUM:
      return {
        ...state,
        plannum: state.plannum.filter((_, index) => index !== action.payload)
      };

    default:
      return state;
  }
}
